export default {
    mlb: [
        {
            averageMoneylines: {
                dog: {
                    avgML: 131.8421052631579,
                    totalGames: 38,
                },
                favorite: {
                    avgML: -144.85555555555555,
                    totalGames: 90,
                },
            },
            def: {
                errors: 101,
                fpct: 0.98,
                ppg: 4.16,
            },
            logoUrl: 'https://firebasestorage.googleapis.com/v0/b/line-prophet.appspot.com/o/mlb%2F33_mlb.png?alt=media',
            off: {
                avg: 0.252,
                hr: 161,
                obp: 0.324,
                oppg: 4.96,
                rbi: 635,
                runs: 4.96,
                slg: 0.425,
            },
            pitching: {
                bb: 489,
                era: 3.67,
                fip: 4,
                homeruns: 558,
                losses: 74,
                saves: 63,
                so: 136,
                wins: 134,
            },
            recordData: {
                ats: '70-64-0',
                awayRecord: '33-35',
                conferenceRecord: '0-0',
                divisionRecord: '0-0',
                homeRecord: '41-25',
                ou: '65-65',
                record: '74-60',
            },
            schedule: [
                {
                    date: 'Mar 27, 2025',
                    location: 'away',
                    opp: 'Texas',
                    oppAbbr: 'TEX',
                    oppId: 109323,
                    opp_pts: '2',
                    points: '5',
                    result: 'W',
                },
                {
                    date: 'Mar 28, 2025',
                    location: 'away',
                    opp: 'Texas',
                    oppAbbr: 'TEX',
                    oppId: 109323,
                    opp_pts: '4',
                    points: '1',
                    result: 'L',
                },
                {
                    date: 'Mar 29, 2025',
                    location: 'away',
                    opp: 'Texas',
                    oppAbbr: 'TEX',
                    oppId: 109323,
                    opp_pts: '4',
                    points: '3',
                    result: 'L',
                },
                {
                    date: 'Mar 30, 2025',
                    location: 'away',
                    opp: 'Texas',
                    oppAbbr: 'TEX',
                    oppId: 109323,
                    opp_pts: '3',
                    points: '2',
                    result: 'L',
                },
                {
                    date: 'Mar 31, 2025',
                    location: 'away',
                    opp: 'Baltimore',
                    oppAbbr: 'BAL',
                    oppId: 7654,
                    opp_pts: '8',
                    points: '5',
                    result: 'L',
                },
                {
                    date: 'Apr 2, 2025',
                    location: 'away',
                    opp: 'Baltimore',
                    oppAbbr: 'BAL',
                    oppId: 7654,
                    opp_pts: '0',
                    points: '3',
                    result: 'W',
                },
                {
                    date: 'Apr 3, 2025',
                    location: 'away',
                    opp: 'Baltimore',
                    oppAbbr: 'BAL',
                    oppId: 7654,
                    opp_pts: '4',
                    points: '8',
                    result: 'W',
                },
                {
                    date: 'Apr 4, 2025',
                    location: 'home',
                    opp: 'St. Louis',
                    oppAbbr: 'STL',
                    oppId: 862,
                    opp_pts: '9',
                    points: '13',
                    result: 'W',
                },
                {
                    date: 'Apr 6, 2025',
                    location: 'home',
                    opp: 'St. Louis',
                    oppAbbr: 'STL',
                    oppId: 862,
                    opp_pts: '4',
                    points: '5',
                    result: 'W',
                },
                {
                    date: 'Apr 6, 2025',
                    location: 'home',
                    opp: 'St. Louis',
                    oppAbbr: 'STL',
                    oppId: 862,
                    opp_pts: '7',
                    points: '18',
                    result: 'W',
                },
                {
                    date: 'Apr 7, 2025',
                    location: 'home',
                    opp: 'Toronto',
                    oppAbbr: 'TOR',
                    oppId: 992,
                    opp_pts: '6',
                    points: '2',
                    result: 'L',
                },
                {
                    date: 'Apr 8, 2025',
                    location: 'home',
                    opp: 'Toronto',
                    oppAbbr: 'TOR',
                    oppId: 992,
                    opp_pts: '6',
                    points: '1',
                    result: 'L',
                },
                {
                    date: 'Apr 9, 2025',
                    location: 'home',
                    opp: 'Toronto',
                    oppAbbr: 'TOR',
                    oppId: 992,
                    opp_pts: '2',
                    points: '1',
                    result: 'L',
                },
                {
                    date: 'Apr 10, 2025',
                    location: 'home',
                    opp: 'Toronto',
                    oppAbbr: 'TOR',
                    oppId: 992,
                    opp_pts: '3',
                    points: '4',
                    result: 'W',
                },
                {
                    date: 'Apr 11, 2025',
                    location: 'away',
                    opp: 'Chi. White Sox',
                    oppAbbr: 'CHW',
                    oppId: 23224,
                    opp_pts: '11',
                    points: '1',
                    result: 'L',
                },
                {
                    date: 'Apr 12, 2025',
                    location: 'away',
                    opp: 'Chi. White Sox',
                    oppAbbr: 'CHW',
                    oppId: 23224,
                    opp_pts: '3',
                    points: '2',
                    result: 'L',
                },
                {
                    date: 'Apr 13, 2025',
                    location: 'away',
                    opp: 'Chi. White Sox',
                    oppAbbr: 'CHW',
                    oppId: 23224,
                    opp_pts: '1',
                    points: '3',
                    result: 'W',
                },
                {
                    date: 'Apr 14, 2025',
                    location: 'away',
                    opp: 'Tampa Bay',
                    oppAbbr: 'TB',
                    oppId: 987346,
                    opp_pts: '16',
                    points: '1',
                    result: 'L',
                },
                {
                    date: 'Apr 15, 2025',
                    location: 'away',
                    opp: 'Tampa Bay',
                    oppAbbr: 'TB',
                    oppId: 987346,
                    opp_pts: '4',
                    points: '7',
                    result: 'W',
                },
                {
                    date: 'Apr 16, 2025',
                    location: 'away',
                    opp: 'Tampa Bay',
                    oppAbbr: 'TB',
                    oppId: 987346,
                    opp_pts: '0',
                    points: '1',
                    result: 'W',
                },
                {
                    date: 'Apr 18, 2025',
                    location: 'home',
                    opp: 'Chi. White Sox',
                    oppAbbr: 'CHW',
                    oppId: 23224,
                    opp_pts: '3',
                    points: '10',
                    result: 'W',
                },
                {
                    date: 'Apr 19, 2025',
                    location: 'home',
                    opp: 'Chi. White Sox',
                    oppAbbr: 'CHW',
                    oppId: 23224,
                    opp_pts: '3',
                    points: '4',
                    result: 'W',
                },
                {
                    date: 'Apr 20, 2025',
                    location: 'home',
                    opp: 'Chi. White Sox',
                    oppAbbr: 'CHW',
                    oppId: 23224,
                    opp_pts: '8',
                    points: '4',
                    result: 'L',
                },
                {
                    date: 'Apr 21, 2025',
                    location: 'home',
                    opp: 'Chi. White Sox',
                    oppAbbr: 'CHW',
                    oppId: 23224,
                    opp_pts: '2',
                    points: '4',
                    result: 'W',
                },
                {
                    date: 'Apr 22, 2025',
                    location: 'home',
                    opp: 'Seattle',
                    oppAbbr: 'SEA',
                    oppId: 232323,
                    opp_pts: '3',
                    points: '8',
                    result: 'W',
                },
                {
                    date: 'Apr 23, 2025',
                    location: 'home',
                    opp: 'Seattle',
                    oppAbbr: 'SEA',
                    oppId: 232323,
                    opp_pts: '8',
                    points: '5',
                    result: 'L',
                },
                {
                    date: 'Apr 24, 2025',
                    location: 'home',
                    opp: 'Seattle',
                    oppAbbr: 'SEA',
                    oppId: 232323,
                    opp_pts: '4',
                    points: '3',
                    result: 'L',
                },
                {
                    date: 'Apr 26, 2025',
                    location: 'away',
                    opp: 'Cleveland',
                    oppAbbr: 'CLE',
                    oppId: 234534,
                    opp_pts: '5',
                    points: '4',
                    result: 'L',
                },
                {
                    date: 'Apr 26, 2025',
                    location: 'away',
                    opp: 'Cleveland',
                    oppAbbr: 'CLE',
                    oppId: 234534,
                    opp_pts: '3',
                    points: '7',
                    result: 'W',
                },
                {
                    date: 'Apr 27, 2025',
                    location: 'away',
                    opp: 'Cleveland',
                    oppAbbr: 'CLE',
                    oppId: 234534,
                    opp_pts: '3',
                    points: '13',
                    result: 'W',
                },
                {
                    date: 'Apr 29, 2025',
                    location: 'away',
                    opp: 'Toronto',
                    oppAbbr: 'TOR',
                    oppId: 992,
                    opp_pts: '2',
                    points: '10',
                    result: 'W',
                },
                {
                    date: 'Apr 30, 2025',
                    location: 'away',
                    opp: 'Toronto',
                    oppAbbr: 'TOR',
                    oppId: 992,
                    opp_pts: '7',
                    points: '6',
                    result: 'L',
                },
                {
                    date: 'May 1, 2025',
                    location: 'away',
                    opp: 'Toronto',
                    oppAbbr: 'TOR',
                    oppId: 992,
                    opp_pts: '4',
                    points: '2',
                    result: 'L',
                },
                {
                    date: 'May 2, 2025',
                    location: 'home',
                    opp: 'Minnesota',
                    oppAbbr: 'MIN',
                    oppId: 9221,
                    opp_pts: '1',
                    points: '6',
                    result: 'W',
                },
                {
                    date: 'May 3, 2025',
                    location: 'home',
                    opp: 'Minnesota',
                    oppAbbr: 'MIN',
                    oppId: 9221,
                    opp_pts: '4',
                    points: '3',
                    result: 'L',
                },
                {
                    date: 'May 4, 2025',
                    location: 'home',
                    opp: 'Minnesota',
                    oppAbbr: 'MIN',
                    oppId: 9221,
                    opp_pts: '5',
                    points: '4',
                    result: 'L',
                },
                {
                    date: 'May 6, 2025',
                    location: 'home',
                    opp: 'Texas',
                    oppAbbr: 'TEX',
                    oppId: 109323,
                    opp_pts: '6',
                    points: '1',
                    result: 'L',
                },
                {
                    date: 'May 7, 2025',
                    location: 'home',
                    opp: 'Texas',
                    oppAbbr: 'TEX',
                    oppId: 109323,
                    opp_pts: '4',
                    points: '6',
                    result: 'W',
                },
                {
                    date: 'May 8, 2025',
                    location: 'home',
                    opp: 'Texas',
                    oppAbbr: 'TEX',
                    oppId: 109323,
                    opp_pts: '0',
                    points: '5',
                    result: 'W',
                },
                {
                    date: 'May 9, 2025',
                    location: 'away',
                    opp: 'Kansas City',
                    oppAbbr: 'KC',
                    oppId: 59936,
                    opp_pts: '2',
                    points: '1',
                    result: 'L',
                },
                {
                    date: 'May 10, 2025',
                    location: 'away',
                    opp: 'Kansas City',
                    oppAbbr: 'KC',
                    oppId: 59936,
                    opp_pts: '1',
                    points: '10',
                    result: 'W',
                },
                {
                    date: 'May 11, 2025',
                    location: 'away',
                    opp: 'Kansas City',
                    oppAbbr: 'KC',
                    oppId: 59936,
                    opp_pts: '1',
                    points: '3',
                    result: 'W',
                },
                {
                    date: 'May 12, 2025',
                    location: 'away',
                    opp: 'Detroit',
                    oppAbbr: 'DET',
                    oppId: 9876,
                    opp_pts: '14',
                    points: '2',
                    result: 'L',
                },
                {
                    date: 'May 13, 2025',
                    location: 'away',
                    opp: 'Detroit',
                    oppAbbr: 'DET',
                    oppId: 9876,
                    opp_pts: '10',
                    points: '9',
                    result: 'L',
                },
                {
                    date: 'May 14, 2025',
                    location: 'away',
                    opp: 'Detroit',
                    oppAbbr: 'DET',
                    oppId: 9876,
                    opp_pts: '6',
                    points: '5',
                    result: 'L',
                },
                {
                    date: 'May 16, 2025',
                    location: 'home',
                    opp: 'Atlanta',
                    oppAbbr: 'ATL',
                    oppId: 56422,
                    opp_pts: '4',
                    points: '2',
                    result: 'L',
                },
                {
                    date: 'May 17, 2025',
                    location: 'home',
                    opp: 'Atlanta',
                    oppAbbr: 'ATL',
                    oppId: 56422,
                    opp_pts: '6',
                    points: '7',
                    result: 'W',
                },
                {
                    date: 'May 18, 2025',
                    location: 'home',
                    opp: 'Atlanta',
                    oppAbbr: 'ATL',
                    oppId: 56422,
                    opp_pts: '10',
                    points: '4',
                    result: 'L',
                },
                {
                    date: 'May 19, 2025',
                    location: 'home',
                    opp: 'N.Y. Mets',
                    oppAbbr: 'NYM',
                    oppId: 3562,
                    opp_pts: '1',
                    points: '3',
                    result: 'W',
                },
                {
                    date: 'May 20, 2025',
                    location: 'home',
                    opp: 'N.Y. Mets',
                    oppAbbr: 'NYM',
                    oppId: 3562,
                    opp_pts: '0',
                    points: '2',
                    result: 'W',
                },
                {
                    date: 'May 21, 2025',
                    location: 'home',
                    opp: 'N.Y. Mets',
                    oppAbbr: 'NYM',
                    oppId: 3562,
                    opp_pts: '5',
                    points: '1',
                    result: 'L',
                },
                {
                    date: 'May 23, 2025',
                    location: 'home',
                    opp: 'Baltimore',
                    oppAbbr: 'BAL',
                    oppId: 7654,
                    opp_pts: '5',
                    points: '19',
                    result: 'W',
                },
                {
                    date: 'May 24, 2025',
                    location: 'home',
                    opp: 'Baltimore',
                    oppAbbr: 'BAL',
                    oppId: 7654,
                    opp_pts: '5',
                    points: '6',
                    result: 'W',
                },
                {
                    date: 'May 24, 2025',
                    location: 'home',
                    opp: 'Baltimore',
                    oppAbbr: 'BAL',
                    oppId: 7654,
                    opp_pts: '2',
                    points: '1',
                    result: 'L',
                },
                {
                    date: 'May 25, 2025',
                    location: 'home',
                    opp: 'Baltimore',
                    oppAbbr: 'BAL',
                    oppId: 7654,
                    opp_pts: '5',
                    points: '1',
                    result: 'L',
                },
                {
                    date: 'May 26, 2025',
                    location: 'away',
                    opp: 'Milwaukee',
                    oppAbbr: 'MIL',
                    oppId: 92343,
                    opp_pts: '3',
                    points: '2',
                    result: 'L',
                },
                {
                    date: 'May 27, 2025',
                    location: 'away',
                    opp: 'Milwaukee',
                    oppAbbr: 'MIL',
                    oppId: 92343,
                    opp_pts: '5',
                    points: '1',
                    result: 'L',
                },
                {
                    date: 'May 28, 2025',
                    location: 'away',
                    opp: 'Milwaukee',
                    oppAbbr: 'MIL',
                    oppId: 92343,
                    opp_pts: '6',
                    points: '5',
                    result: 'L',
                },
                {
                    date: 'May 30, 2025',
                    location: 'away',
                    opp: 'Atlanta',
                    oppAbbr: 'ATL',
                    oppId: 56422,
                    opp_pts: '1',
                    points: '5',
                    result: 'W',
                },
                {
                    date: 'May 31, 2025',
                    location: 'away',
                    opp: 'Atlanta',
                    oppAbbr: 'ATL',
                    oppId: 56422,
                    opp_pts: '5',
                    points: '0',
                    result: 'L',
                },
                {
                    date: 'Jun 1, 2025',
                    location: 'away',
                    opp: 'Atlanta',
                    oppAbbr: 'ATL',
                    oppId: 56422,
                    opp_pts: '1',
                    points: '3',
                    result: 'W',
                },
                {
                    date: 'Jun 2, 2025',
                    location: 'home',
                    opp: 'L.A. Angels',
                    oppAbbr: 'LAA',
                    oppId: 9322,
                    opp_pts: '7',
                    points: '6',
                    result: 'L',
                },
                {
                    date: 'Jun 3, 2025',
                    location: 'home',
                    opp: 'L.A. Angels',
                    oppAbbr: 'LAA',
                    oppId: 9322,
                    opp_pts: '4',
                    points: '3',
                    result: 'L',
                },
                {
                    date: 'Jun 4, 2025',
                    location: 'home',
                    opp: 'L.A. Angels',
                    oppAbbr: 'LAA',
                    oppId: 9322,
                    opp_pts: '9',
                    points: '11',
                    result: 'W',
                },
                {
                    date: 'Jun 6, 2025',
                    location: 'away',
                    opp: 'N.Y. Yankees',
                    oppAbbr: 'NYY',
                    oppId: 1112,
                    opp_pts: '9',
                    points: '6',
                    result: 'L',
                },
                {
                    date: 'Jun 7, 2025',
                    location: 'away',
                    opp: 'N.Y. Yankees',
                    oppAbbr: 'NYY',
                    oppId: 1112,
                    opp_pts: '7',
                    points: '10',
                    result: 'W',
                },
                {
                    date: 'Jun 8, 2025',
                    location: 'away',
                    opp: 'N.Y. Yankees',
                    oppAbbr: 'NYY',
                    oppId: 1112,
                    opp_pts: '7',
                    points: '11',
                    result: 'W',
                },
                {
                    date: 'Jun 9, 2025',
                    location: 'home',
                    opp: 'Tampa Bay',
                    oppAbbr: 'TB',
                    oppId: 987346,
                    opp_pts: '10',
                    points: '8',
                    result: 'L',
                },
                {
                    date: 'Jun 10, 2025',
                    location: 'home',
                    opp: 'Tampa Bay',
                    oppAbbr: 'TB',
                    oppId: 987346,
                    opp_pts: '1',
                    points: '3',
                    result: 'W',
                },
                {
                    date: 'Jun 11, 2025',
                    location: 'home',
                    opp: 'Tampa Bay',
                    oppAbbr: 'TB',
                    oppId: 987346,
                    opp_pts: '3',
                    points: '4',
                    result: 'W',
                },
                {
                    date: 'Jun 13, 2025',
                    location: 'home',
                    opp: 'N.Y. Yankees',
                    oppAbbr: 'NYY',
                    oppId: 1112,
                    opp_pts: '1',
                    points: '2',
                    result: 'W',
                },
                {
                    date: 'Jun 14, 2025',
                    location: 'home',
                    opp: 'N.Y. Yankees',
                    oppAbbr: 'NYY',
                    oppId: 1112,
                    opp_pts: '3',
                    points: '4',
                    result: 'W',
                },
                {
                    date: 'Jun 15, 2025',
                    location: 'home',
                    opp: 'N.Y. Yankees',
                    oppAbbr: 'NYY',
                    oppId: 1112,
                    opp_pts: '0',
                    points: '2',
                    result: 'W',
                },
                {
                    date: 'Jun 16, 2025',
                    location: 'away',
                    opp: 'Seattle',
                    oppAbbr: 'SEA',
                    oppId: 232323,
                    opp_pts: '0',
                    points: '2',
                    result: 'W',
                },
                {
                    date: 'Jun 17, 2025',
                    location: 'away',
                    opp: 'Seattle',
                    oppAbbr: 'SEA',
                    oppId: 232323,
                    opp_pts: '8',
                    points: '0',
                    result: 'L',
                },
                {
                    date: 'Jun 18, 2025',
                    location: 'away',
                    opp: 'Seattle',
                    oppAbbr: 'SEA',
                    oppId: 232323,
                    opp_pts: '1',
                    points: '3',
                    result: 'W',
                },
                {
                    date: 'Jun 20, 2025',
                    location: 'away',
                    opp: 'San Francisco',
                    oppAbbr: 'SF',
                    oppId: 102324,
                    opp_pts: '5',
                    points: '7',
                    result: 'W',
                },
                {
                    date: 'Jun 21, 2025',
                    location: 'away',
                    opp: 'San Francisco',
                    oppAbbr: 'SF',
                    oppId: 102324,
                    opp_pts: '3',
                    points: '2',
                    result: 'L',
                },
                {
                    date: 'Jun 22, 2025',
                    location: 'away',
                    opp: 'San Francisco',
                    oppAbbr: 'SF',
                    oppId: 102324,
                    opp_pts: '9',
                    points: '5',
                    result: 'L',
                },
                {
                    date: 'Jun 23, 2025',
                    location: 'away',
                    opp: 'L.A. Angels',
                    oppAbbr: 'LAA',
                    oppId: 9322,
                    opp_pts: '9',
                    points: '5',
                    result: 'L',
                },
                {
                    date: 'Jun 24, 2025',
                    location: 'away',
                    opp: 'L.A. Angels',
                    oppAbbr: 'LAA',
                    oppId: 9322,
                    opp_pts: '3',
                    points: '2',
                    result: 'L',
                },
                {
                    date: 'Jun 25, 2025',
                    location: 'away',
                    opp: 'L.A. Angels',
                    oppAbbr: 'LAA',
                    oppId: 9322,
                    opp_pts: '5',
                    points: '2',
                    result: 'L',
                },
                {
                    date: 'Jun 27, 2025',
                    location: 'home',
                    opp: 'Toronto',
                    oppAbbr: 'TOR',
                    oppId: 992,
                    opp_pts: '9',
                    points: '0',
                    result: 'L',
                },
                {
                    date: 'Jun 28, 2025',
                    location: 'home',
                    opp: 'Toronto',
                    oppAbbr: 'TOR',
                    oppId: 992,
                    opp_pts: '1',
                    points: '15',
                    result: 'W',
                },
                {
                    date: 'Jun 29, 2025',
                    location: 'home',
                    opp: 'Toronto',
                    oppAbbr: 'TOR',
                    oppId: 992,
                    opp_pts: '5',
                    points: '3',
                    result: 'L',
                },
                {
                    date: 'Jun 30, 2025',
                    location: 'home',
                    opp: 'Cincinnati',
                    oppAbbr: 'CIN',
                    oppId: 92929,
                    opp_pts: '6',
                    points: '13',
                    result: 'W',
                },
                {
                    date: 'Jul 2, 2025',
                    location: 'home',
                    opp: 'Cincinnati',
                    oppAbbr: 'CIN',
                    oppId: 92929,
                    opp_pts: '3',
                    points: '5',
                    result: 'W',
                },
                {
                    date: 'Jul 2, 2025',
                    location: 'home',
                    opp: 'Cincinnati',
                    oppAbbr: 'CIN',
                    oppId: 92929,
                    opp_pts: '8',
                    points: '4',
                    result: 'L',
                },
                {
                    date: 'Jul 4, 2025',
                    location: 'away',
                    opp: 'Washington',
                    oppAbbr: 'WAS',
                    oppId: 10923,
                    opp_pts: '2',
                    points: '11',
                    result: 'W',
                },
                {
                    date: 'Jul 5, 2025',
                    location: 'away',
                    opp: 'Washington',
                    oppAbbr: 'WAS',
                    oppId: 10923,
                    opp_pts: '3',
                    points: '10',
                    result: 'W',
                },
                {
                    date: 'Jul 6, 2025',
                    location: 'away',
                    opp: 'Washington',
                    oppAbbr: 'WAS',
                    oppId: 10923,
                    opp_pts: '4',
                    points: '6',
                    result: 'W',
                },
                {
                    date: 'Jul 7, 2025',
                    location: 'home',
                    opp: 'Colorado',
                    oppAbbr: 'COL',
                    oppId: 593423,
                    opp_pts: '3',
                    points: '9',
                    result: 'W',
                },
                {
                    date: 'Jul 8, 2025',
                    location: 'home',
                    opp: 'Colorado',
                    oppAbbr: 'COL',
                    oppId: 593423,
                    opp_pts: '2',
                    points: '10',
                    result: 'W',
                },
                {
                    date: 'Jul 9, 2025',
                    location: 'home',
                    opp: 'Colorado',
                    oppAbbr: 'COL',
                    oppId: 593423,
                    opp_pts: '2',
                    points: '10',
                    result: 'W',
                },
                {
                    date: 'Jul 10, 2025',
                    location: 'home',
                    opp: 'Tampa Bay',
                    oppAbbr: 'TB',
                    oppId: 987346,
                    opp_pts: '3',
                    points: '4',
                    result: 'W',
                },
                {
                    date: 'Jul 11, 2025',
                    location: 'home',
                    opp: 'Tampa Bay',
                    oppAbbr: 'TB',
                    oppId: 987346,
                    opp_pts: '4',
                    points: '5',
                    result: 'W',
                },
                {
                    date: 'Jul 12, 2025',
                    location: 'home',
                    opp: 'Tampa Bay',
                    oppAbbr: 'TB',
                    oppId: 987346,
                    opp_pts: '0',
                    points: '1',
                    result: 'W',
                },
                {
                    date: 'Jul 13, 2025',
                    location: 'home',
                    opp: 'Tampa Bay',
                    oppAbbr: 'TB',
                    oppId: 987346,
                    opp_pts: '1',
                    points: '4',
                    result: 'W',
                },
                {
                    date: 'Jul 18, 2025',
                    location: 'away',
                    opp: 'Chi. Cubs',
                    oppAbbr: 'CHC',
                    oppId: 354,
                    opp_pts: '4',
                    points: '1',
                    result: 'L',
                },
                {
                    date: 'Jul 19, 2025',
                    location: 'away',
                    opp: 'Chi. Cubs',
                    oppAbbr: 'CHC',
                    oppId: 354,
                    opp_pts: '6',
                    points: '0',
                    result: 'L',
                },
                {
                    date: 'Jul 20, 2025',
                    location: 'away',
                    opp: 'Chi. Cubs',
                    oppAbbr: 'CHC',
                    oppId: 354,
                    opp_pts: '1',
                    points: '6',
                    result: 'W',
                },
                {
                    date: 'Jul 21, 2025',
                    location: 'away',
                    opp: 'Philadelphia',
                    oppAbbr: 'PHI',
                    oppId: 2239,
                    opp_pts: '3',
                    points: '2',
                    result: 'L',
                },
                {
                    date: 'Jul 22, 2025',
                    location: 'away',
                    opp: 'Philadelphia',
                    oppAbbr: 'PHI',
                    oppId: 2239,
                    opp_pts: '4',
                    points: '1',
                    result: 'L',
                },
                {
                    date: 'Jul 23, 2025',
                    location: 'away',
                    opp: 'Philadelphia',
                    oppAbbr: 'PHI',
                    oppId: 2239,
                    opp_pts: '8',
                    points: '9',
                    result: 'W',
                },
                {
                    date: 'Jul 25, 2025',
                    location: 'home',
                    opp: 'L.A. Dodgers',
                    oppAbbr: 'LAD',
                    oppId: 4353,
                    opp_pts: '5',
                    points: '2',
                    result: 'L',
                },
                {
                    date: 'Jul 26, 2025',
                    location: 'home',
                    opp: 'L.A. Dodgers',
                    oppAbbr: 'LAD',
                    oppId: 4353,
                    opp_pts: '2',
                    points: '4',
                    result: 'W',
                },
                {
                    date: 'Jul 27, 2025',
                    location: 'home',
                    opp: 'L.A. Dodgers',
                    oppAbbr: 'LAD',
                    oppId: 4353,
                    opp_pts: '3',
                    points: '4',
                    result: 'W',
                },
                {
                    date: 'Jul 28, 2025',
                    location: 'away',
                    opp: 'Minnesota',
                    oppAbbr: 'MIN',
                    oppId: 9221,
                    opp_pts: '5',
                    points: '4',
                    result: 'L',
                },
                {
                    date: 'Jul 29, 2025',
                    location: 'away',
                    opp: 'Minnesota',
                    oppAbbr: 'MIN',
                    oppId: 9221,
                    opp_pts: '5',
                    points: '8',
                    result: 'W',
                },
                {
                    date: 'Jul 30, 2025',
                    location: 'away',
                    opp: 'Minnesota',
                    oppAbbr: 'MIN',
                    oppId: 9221,
                    opp_pts: '1',
                    points: '13',
                    result: 'W',
                },
                {
                    date: 'Aug 1, 2025',
                    location: 'home',
                    opp: 'Houston',
                    oppAbbr: 'HOU',
                    oppId: 32235,
                    opp_pts: '1',
                    points: '2',
                    result: 'W',
                },
                {
                    date: 'Aug 2, 2025',
                    location: 'home',
                    opp: 'Houston',
                    oppAbbr: 'HOU',
                    oppId: 32235,
                    opp_pts: '3',
                    points: '7',
                    result: 'W',
                },
                {
                    date: 'Aug 3, 2025',
                    location: 'home',
                    opp: 'Houston',
                    oppAbbr: 'HOU',
                    oppId: 32235,
                    opp_pts: '1',
                    points: '6',
                    result: 'W',
                },
                {
                    date: 'Aug 4, 2025',
                    location: 'home',
                    opp: 'Kansas City',
                    oppAbbr: 'KC',
                    oppId: 59936,
                    opp_pts: '5',
                    points: '8',
                    result: 'W',
                },
                {
                    date: 'Aug 5, 2025',
                    location: 'home',
                    opp: 'Kansas City',
                    oppAbbr: 'KC',
                    oppId: 59936,
                    opp_pts: '2',
                    points: '6',
                    result: 'W',
                },
                {
                    date: 'Aug 6, 2025',
                    location: 'home',
                    opp: 'Kansas City',
                    oppAbbr: 'KC',
                    oppId: 59936,
                    opp_pts: '7',
                    points: '3',
                    result: 'L',
                },
                {
                    date: 'Aug 8, 2025',
                    location: 'away',
                    opp: 'San Diego',
                    oppAbbr: 'SD',
                    oppId: 234535,
                    opp_pts: '2',
                    points: '10',
                    result: 'W',
                },
                {
                    date: 'Aug 9, 2025',
                    location: 'away',
                    opp: 'San Diego',
                    oppAbbr: 'SD',
                    oppId: 234535,
                    opp_pts: '5',
                    points: '4',
                    result: 'L',
                },
                {
                    date: 'Aug 10, 2025',
                    location: 'away',
                    opp: 'San Diego',
                    oppAbbr: 'SD',
                    oppId: 234535,
                    opp_pts: '6',
                    points: '2',
                    result: 'L',
                },
                {
                    date: 'Aug 11, 2025',
                    location: 'away',
                    opp: 'Houston',
                    oppAbbr: 'HOU',
                    oppId: 32235,
                    opp_pts: '7',
                    points: '6',
                    result: 'L',
                },
                {
                    date: 'Aug 12, 2025',
                    location: 'away',
                    opp: 'Houston',
                    oppAbbr: 'HOU',
                    oppId: 32235,
                    opp_pts: '1',
                    points: '14',
                    result: 'W',
                },
                {
                    date: 'Aug 13, 2025',
                    location: 'away',
                    opp: 'Houston',
                    oppAbbr: 'HOU',
                    oppId: 32235,
                    opp_pts: '4',
                    points: '1',
                    result: 'L',
                },
                {
                    date: 'Aug 15, 2025',
                    location: 'home',
                    opp: 'Miami',
                    oppAbbr: 'MIA',
                    oppId: 599325,
                    opp_pts: '1',
                    points: '2',
                    result: 'W',
                },
                {
                    date: 'Aug 16, 2025',
                    location: 'home',
                    opp: 'Miami',
                    oppAbbr: 'MIA',
                    oppId: 599325,
                    opp_pts: '5',
                    points: '7',
                    result: 'W',
                },
                {
                    date: 'Aug 17, 2025',
                    location: 'home',
                    opp: 'Miami',
                    oppAbbr: 'MIA',
                    oppId: 599325,
                    opp_pts: '5',
                    points: '3',
                    result: 'L',
                },
                {
                    date: 'Aug 18, 2025',
                    location: 'home',
                    opp: 'Baltimore',
                    oppAbbr: 'BAL',
                    oppId: 7654,
                    opp_pts: '6',
                    points: '3',
                    result: 'L',
                },
                {
                    date: 'Aug 19, 2025',
                    location: 'home',
                    opp: 'Baltimore',
                    oppAbbr: 'BAL',
                    oppId: 7654,
                    opp_pts: '4',
                    points: '3',
                    result: 'L',
                },
                {
                    date: 'Aug 21, 2025',
                    location: 'away',
                    opp: 'N.Y. Yankees',
                    oppAbbr: 'NYY',
                    oppId: 1112,
                    opp_pts: '3',
                    points: '6',
                    result: 'W',
                },
                {
                    date: 'Aug 22, 2025',
                    location: 'away',
                    opp: 'N.Y. Yankees',
                    oppAbbr: 'NYY',
                    oppId: 1112,
                    opp_pts: '0',
                    points: '1',
                    result: 'W',
                },
                {
                    date: 'Aug 23, 2025',
                    location: 'away',
                    opp: 'N.Y. Yankees',
                    oppAbbr: 'NYY',
                    oppId: 1112,
                    opp_pts: '1',
                    points: '12',
                    result: 'W',
                },
                {
                    date: 'Aug 24, 2025',
                    location: 'away',
                    opp: 'N.Y. Yankees',
                    oppAbbr: 'NYY',
                    oppId: 1112,
                    opp_pts: '7',
                    points: '2',
                    result: 'L',
                },
                {
                    date: 'Aug 25, 2025',
                    location: 'away',
                    opp: 'Baltimore',
                    oppAbbr: 'BAL',
                    oppId: 7654,
                    opp_pts: '3',
                    points: '4',
                    result: 'W',
                },
                {
                    date: 'Aug 26, 2025',
                    location: 'away',
                    opp: 'Baltimore',
                    oppAbbr: 'BAL',
                    oppId: 7654,
                    opp_pts: '0',
                    points: '5',
                    result: 'W',
                },
                {
                    date: 'Aug 27, 2025',
                    location: 'away',
                    opp: 'Baltimore',
                    oppAbbr: 'BAL',
                    oppId: 7654,
                    opp_pts: '2',
                    points: '3',
                    result: 'W',
                },
            ],
            sos: 6,
            teamId: 33,
            teamName: 'Boston Red Sox',
            abbr: 'BOS',
            primaryColor: '#bd3039',
        },
        {
            averageMoneylines: {
                dog: {
                    avgML: 126.44067796610169,
                    totalGames: 59,
                },
                favorite: {
                    avgML: -131.6216216216216,
                    totalGames: 74,
                },
            },
            def: {
                errors: 69,
                fpct: 0.986,
                ppg: 4.89,
            },
            logoUrl: 'https://firebasestorage.googleapis.com/v0/b/line-prophet.appspot.com/o/mlb%2F7654_mlb.png?alt=media',
            off: {
                avg: 0.24,
                hr: 159,
                obp: 0.305,
                oppg: 4.3,
                rbi: 541,
                runs: 4.3,
                slg: 0.402,
            },
            pitching: {
                bb: 611,
                era: 4.68,
                fip: 4.45,
                homeruns: 651,
                losses: 60,
                saves: 46,
                so: 181,
                wins: 133,
            },
            recordData: {
                ats: '65-68-0',
                awayRecord: '29-37',
                conferenceRecord: '0-0',
                divisionRecord: '0-0',
                homeRecord: '31-36',
                ou: '56-73',
                record: '60-73',
            },
            schedule: [
                {
                    date: 'Mar 27, 2025',
                    location: 'away',
                    opp: 'Toronto',
                    oppAbbr: 'TOR',
                    oppId: 992,
                    opp_pts: '2',
                    points: '12',
                    result: 'W',
                },
                {
                    date: 'Mar 28, 2025',
                    location: 'away',
                    opp: 'Toronto',
                    oppAbbr: 'TOR',
                    oppId: 992,
                    opp_pts: '8',
                    points: '2',
                    result: 'L',
                },
                {
                    date: 'Mar 29, 2025',
                    location: 'away',
                    opp: 'Toronto',
                    oppAbbr: 'TOR',
                    oppId: 992,
                    opp_pts: '5',
                    points: '9',
                    result: 'W',
                },
                {
                    date: 'Mar 30, 2025',
                    location: 'away',
                    opp: 'Toronto',
                    oppAbbr: 'TOR',
                    oppId: 992,
                    opp_pts: '3',
                    points: '1',
                    result: 'L',
                },
                {
                    date: 'Mar 31, 2025',
                    location: 'home',
                    opp: 'Boston',
                    oppAbbr: 'BOS',
                    oppId: 33,
                    opp_pts: '5',
                    points: '8',
                    result: 'W',
                },
                {
                    date: 'Apr 2, 2025',
                    location: 'home',
                    opp: 'Boston',
                    oppAbbr: 'BOS',
                    oppId: 33,
                    opp_pts: '3',
                    points: '0',
                    result: 'L',
                },
                {
                    date: 'Apr 3, 2025',
                    location: 'home',
                    opp: 'Boston',
                    oppAbbr: 'BOS',
                    oppId: 33,
                    opp_pts: '8',
                    points: '4',
                    result: 'L',
                },
                {
                    date: 'Apr 4, 2025',
                    location: 'away',
                    opp: 'Kansas City',
                    oppAbbr: 'KC',
                    oppId: 59936,
                    opp_pts: '8',
                    points: '2',
                    result: 'L',
                },
                {
                    date: 'Apr 5, 2025',
                    location: 'away',
                    opp: 'Kansas City',
                    oppAbbr: 'KC',
                    oppId: 59936,
                    opp_pts: '1',
                    points: '8',
                    result: 'W',
                },
                {
                    date: 'Apr 6, 2025',
                    location: 'away',
                    opp: 'Kansas City',
                    oppAbbr: 'KC',
                    oppId: 59936,
                    opp_pts: '4',
                    points: '1',
                    result: 'L',
                },
                {
                    date: 'Apr 7, 2025',
                    location: 'away',
                    opp: 'Arizona',
                    oppAbbr: 'ARI',
                    oppId: 873434,
                    opp_pts: '1',
                    points: '5',
                    result: 'W',
                },
                {
                    date: 'Apr 8, 2025',
                    location: 'away',
                    opp: 'Arizona',
                    oppAbbr: 'ARI',
                    oppId: 873434,
                    opp_pts: '4',
                    points: '3',
                    result: 'L',
                },
                {
                    date: 'Apr 9, 2025',
                    location: 'away',
                    opp: 'Arizona',
                    oppAbbr: 'ARI',
                    oppId: 873434,
                    opp_pts: '9',
                    points: '0',
                    result: 'L',
                },
                {
                    date: 'Apr 12, 2025',
                    location: 'home',
                    opp: 'Toronto',
                    oppAbbr: 'TOR',
                    oppId: 992,
                    opp_pts: '4',
                    points: '5',
                    result: 'W',
                },
                {
                    date: 'Apr 13, 2025',
                    location: 'home',
                    opp: 'Toronto',
                    oppAbbr: 'TOR',
                    oppId: 992,
                    opp_pts: '7',
                    points: '6',
                    result: 'L',
                },
                {
                    date: 'Apr 15, 2025',
                    location: 'home',
                    opp: 'Cleveland',
                    oppAbbr: 'CLE',
                    oppId: 234534,
                    opp_pts: '6',
                    points: '3',
                    result: 'L',
                },
                {
                    date: 'Apr 16, 2025',
                    location: 'home',
                    opp: 'Cleveland',
                    oppAbbr: 'CLE',
                    oppId: 234534,
                    opp_pts: '1',
                    points: '9',
                    result: 'W',
                },
                {
                    date: 'Apr 17, 2025',
                    location: 'home',
                    opp: 'Cleveland',
                    oppAbbr: 'CLE',
                    oppId: 234534,
                    opp_pts: '2',
                    points: '6',
                    result: 'W',
                },
                {
                    date: 'Apr 18, 2025',
                    location: 'home',
                    opp: 'Cincinnati',
                    oppAbbr: 'CIN',
                    oppId: 92929,
                    opp_pts: '8',
                    points: '3',
                    result: 'L',
                },
                {
                    date: 'Apr 19, 2025',
                    location: 'home',
                    opp: 'Cincinnati',
                    oppAbbr: 'CIN',
                    oppId: 92929,
                    opp_pts: '5',
                    points: '9',
                    result: 'W',
                },
                {
                    date: 'Apr 20, 2025',
                    location: 'home',
                    opp: 'Cincinnati',
                    oppAbbr: 'CIN',
                    oppId: 92929,
                    opp_pts: '24',
                    points: '2',
                    result: 'L',
                },
                {
                    date: 'Apr 22, 2025',
                    location: 'away',
                    opp: 'Washington',
                    oppAbbr: 'WAS',
                    oppId: 10923,
                    opp_pts: '7',
                    points: '0',
                    result: 'L',
                },
                {
                    date: 'Apr 23, 2025',
                    location: 'away',
                    opp: 'Washington',
                    oppAbbr: 'WAS',
                    oppId: 10923,
                    opp_pts: '4',
                    points: '3',
                    result: 'L',
                },
                {
                    date: 'Apr 24, 2025',
                    location: 'away',
                    opp: 'Washington',
                    oppAbbr: 'WAS',
                    oppId: 10923,
                    opp_pts: '1',
                    points: '2',
                    result: 'W',
                },
                {
                    date: 'Apr 26, 2025',
                    location: 'away',
                    opp: 'Detroit',
                    oppAbbr: 'DET',
                    oppId: 9876,
                    opp_pts: '4',
                    points: '3',
                    result: 'L',
                },
                {
                    date: 'Apr 26, 2025',
                    location: 'away',
                    opp: 'Detroit',
                    oppAbbr: 'DET',
                    oppId: 9876,
                    opp_pts: '6',
                    points: '2',
                    result: 'L',
                },
                {
                    date: 'Apr 27, 2025',
                    location: 'away',
                    opp: 'Detroit',
                    oppAbbr: 'DET',
                    oppId: 9876,
                    opp_pts: '7',
                    points: '0',
                    result: 'L',
                },
                {
                    date: 'Apr 28, 2025',
                    location: 'home',
                    opp: 'N.Y. Yankees',
                    oppAbbr: 'NYY',
                    oppId: 1112,
                    opp_pts: '3',
                    points: '4',
                    result: 'W',
                },
                {
                    date: 'Apr 29, 2025',
                    location: 'home',
                    opp: 'N.Y. Yankees',
                    oppAbbr: 'NYY',
                    oppId: 1112,
                    opp_pts: '15',
                    points: '3',
                    result: 'L',
                },
                {
                    date: 'Apr 30, 2025',
                    location: 'home',
                    opp: 'N.Y. Yankees',
                    oppAbbr: 'NYY',
                    oppId: 1112,
                    opp_pts: '4',
                    points: '5',
                    result: 'W',
                },
                {
                    date: 'May 2, 2025',
                    location: 'home',
                    opp: 'Kansas City',
                    oppAbbr: 'KC',
                    oppId: 59936,
                    opp_pts: '0',
                    points: '3',
                    result: 'W',
                },
                {
                    date: 'May 3, 2025',
                    location: 'home',
                    opp: 'Kansas City',
                    oppAbbr: 'KC',
                    oppId: 59936,
                    opp_pts: '4',
                    points: '0',
                    result: 'L',
                },
                {
                    date: 'May 4, 2025',
                    location: 'home',
                    opp: 'Kansas City',
                    oppAbbr: 'KC',
                    oppId: 59936,
                    opp_pts: '11',
                    points: '6',
                    result: 'L',
                },
                {
                    date: 'May 6, 2025',
                    location: 'away',
                    opp: 'Minnesota',
                    oppAbbr: 'MIN',
                    oppId: 9221,
                    opp_pts: '9',
                    points: '1',
                    result: 'L',
                },
                {
                    date: 'May 7, 2025',
                    location: 'away',
                    opp: 'Minnesota',
                    oppAbbr: 'MIN',
                    oppId: 9221,
                    opp_pts: '5',
                    points: '2',
                    result: 'L',
                },
                {
                    date: 'May 8, 2025',
                    location: 'away',
                    opp: 'Minnesota',
                    oppAbbr: 'MIN',
                    oppId: 9221,
                    opp_pts: '5',
                    points: '2',
                    result: 'L',
                },
                {
                    date: 'May 9, 2025',
                    location: 'away',
                    opp: 'L.A. Angels',
                    oppAbbr: 'LAA',
                    oppId: 9322,
                    opp_pts: '1',
                    points: '4',
                    result: 'W',
                },
                {
                    date: 'May 10, 2025',
                    location: 'away',
                    opp: 'L.A. Angels',
                    oppAbbr: 'LAA',
                    oppId: 9322,
                    opp_pts: '5',
                    points: '2',
                    result: 'L',
                },
                {
                    date: 'May 11, 2025',
                    location: 'away',
                    opp: 'L.A. Angels',
                    oppAbbr: 'LAA',
                    oppId: 9322,
                    opp_pts: '3',
                    points: '7',
                    result: 'W',
                },
                {
                    date: 'May 14, 2025',
                    location: 'home',
                    opp: 'Minnesota',
                    oppAbbr: 'MIN',
                    oppId: 9221,
                    opp_pts: '6',
                    points: '3',
                    result: 'L',
                },
                {
                    date: 'May 14, 2025',
                    location: 'home',
                    opp: 'Minnesota',
                    oppAbbr: 'MIN',
                    oppId: 9221,
                    opp_pts: '8',
                    points: '6',
                    result: 'L',
                },
                {
                    date: 'May 15, 2025',
                    location: 'home',
                    opp: 'Minnesota',
                    oppAbbr: 'MIN',
                    oppId: 9221,
                    opp_pts: '4',
                    points: '0',
                    result: 'L',
                },
                {
                    date: 'May 16, 2025',
                    location: 'home',
                    opp: 'Washington',
                    oppAbbr: 'WAS',
                    oppId: 10923,
                    opp_pts: '4',
                    points: '3',
                    result: 'L',
                },
                {
                    date: 'May 17, 2025',
                    location: 'home',
                    opp: 'Washington',
                    oppAbbr: 'WAS',
                    oppId: 10923,
                    opp_pts: '10',
                    points: '6',
                    result: 'L',
                },
                {
                    date: 'May 18, 2025',
                    location: 'home',
                    opp: 'Washington',
                    oppAbbr: 'WAS',
                    oppId: 10923,
                    opp_pts: '10',
                    points: '4',
                    result: 'L',
                },
                {
                    date: 'May 19, 2025',
                    location: 'away',
                    opp: 'Milwaukee',
                    oppAbbr: 'MIL',
                    oppId: 92343,
                    opp_pts: '5',
                    points: '4',
                    result: 'L',
                },
                {
                    date: 'May 20, 2025',
                    location: 'away',
                    opp: 'Milwaukee',
                    oppAbbr: 'MIL',
                    oppId: 92343,
                    opp_pts: '5',
                    points: '2',
                    result: 'L',
                },
                {
                    date: 'May 21, 2025',
                    location: 'away',
                    opp: 'Milwaukee',
                    oppAbbr: 'MIL',
                    oppId: 92343,
                    opp_pts: '4',
                    points: '8',
                    result: 'W',
                },
                {
                    date: 'May 23, 2025',
                    location: 'away',
                    opp: 'Boston',
                    oppAbbr: 'BOS',
                    oppId: 33,
                    opp_pts: '19',
                    points: '5',
                    result: 'L',
                },
                {
                    date: 'May 24, 2025',
                    location: 'away',
                    opp: 'Boston',
                    oppAbbr: 'BOS',
                    oppId: 33,
                    opp_pts: '6',
                    points: '5',
                    result: 'L',
                },
                {
                    date: 'May 24, 2025',
                    location: 'away',
                    opp: 'Boston',
                    oppAbbr: 'BOS',
                    oppId: 33,
                    opp_pts: '1',
                    points: '2',
                    result: 'W',
                },
                {
                    date: 'May 25, 2025',
                    location: 'away',
                    opp: 'Boston',
                    oppAbbr: 'BOS',
                    oppId: 33,
                    opp_pts: '1',
                    points: '5',
                    result: 'W',
                },
                {
                    date: 'May 26, 2025',
                    location: 'home',
                    opp: 'St. Louis',
                    oppAbbr: 'STL',
                    oppId: 862,
                    opp_pts: '2',
                    points: '5',
                    result: 'W',
                },
                {
                    date: 'May 27, 2025',
                    location: 'home',
                    opp: 'St. Louis',
                    oppAbbr: 'STL',
                    oppId: 862,
                    opp_pts: '7',
                    points: '4',
                    result: 'L',
                },
                {
                    date: 'May 28, 2025',
                    location: 'home',
                    opp: 'St. Louis',
                    oppAbbr: 'STL',
                    oppId: 862,
                    opp_pts: '6',
                    points: '4',
                    result: 'L',
                },
                {
                    date: 'May 30, 2025',
                    location: 'home',
                    opp: 'Chi. White Sox',
                    oppAbbr: 'CHW',
                    oppId: 23224,
                    opp_pts: '1',
                    points: '2',
                    result: 'W',
                },
                {
                    date: 'May 31, 2025',
                    location: 'home',
                    opp: 'Chi. White Sox',
                    oppAbbr: 'CHW',
                    oppId: 23224,
                    opp_pts: '2',
                    points: '4',
                    result: 'W',
                },
                {
                    date: 'Jun 1, 2025',
                    location: 'home',
                    opp: 'Chi. White Sox',
                    oppAbbr: 'CHW',
                    oppId: 23224,
                    opp_pts: '2',
                    points: '3',
                    result: 'W',
                },
                {
                    date: 'Jun 3, 2025',
                    location: 'away',
                    opp: 'Seattle',
                    oppAbbr: 'SEA',
                    oppId: 232323,
                    opp_pts: '1',
                    points: '5',
                    result: 'W',
                },
                {
                    date: 'Jun 4, 2025',
                    location: 'away',
                    opp: 'Seattle',
                    oppAbbr: 'SEA',
                    oppId: 232323,
                    opp_pts: '2',
                    points: '3',
                    result: 'W',
                },
                {
                    date: 'Jun 5, 2025',
                    location: 'away',
                    opp: 'Seattle',
                    oppAbbr: 'SEA',
                    oppId: 232323,
                    opp_pts: '3',
                    points: '4',
                    result: 'W',
                },
                {
                    date: 'Jun 6, 2025',
                    location: 'away',
                    opp: 'Athletics',
                    oppAbbr: 'OAK',
                    oppId: 45996,
                    opp_pts: '5',
                    points: '4',
                    result: 'L',
                },
                {
                    date: 'Jun 7, 2025',
                    location: 'away',
                    opp: 'Athletics',
                    oppAbbr: 'OAK',
                    oppId: 45996,
                    opp_pts: '4',
                    points: '7',
                    result: 'W',
                },
                {
                    date: 'Jun 8, 2025',
                    location: 'away',
                    opp: 'Athletics',
                    oppAbbr: 'OAK',
                    oppId: 45996,
                    opp_pts: '5',
                    points: '1',
                    result: 'L',
                },
                {
                    date: 'Jun 10, 2025',
                    location: 'home',
                    opp: 'Detroit',
                    oppAbbr: 'DET',
                    oppId: 9876,
                    opp_pts: '5',
                    points: '3',
                    result: 'L',
                },
                {
                    date: 'Jun 11, 2025',
                    location: 'home',
                    opp: 'Detroit',
                    oppAbbr: 'DET',
                    oppId: 9876,
                    opp_pts: '1',
                    points: '10',
                    result: 'W',
                },
                {
                    date: 'Jun 12, 2025',
                    location: 'home',
                    opp: 'Detroit',
                    oppAbbr: 'DET',
                    oppId: 9876,
                    opp_pts: '4',
                    points: '1',
                    result: 'L',
                },
                {
                    date: 'Jun 13, 2025',
                    location: 'home',
                    opp: 'L.A. Angels',
                    oppAbbr: 'LAA',
                    oppId: 9322,
                    opp_pts: '0',
                    points: '2',
                    result: 'W',
                },
                {
                    date: 'Jun 14, 2025',
                    location: 'home',
                    opp: 'L.A. Angels',
                    oppAbbr: 'LAA',
                    oppId: 9322,
                    opp_pts: '5',
                    points: '6',
                    result: 'W',
                },
                {
                    date: 'Jun 15, 2025',
                    location: 'home',
                    opp: 'L.A. Angels',
                    oppAbbr: 'LAA',
                    oppId: 9322,
                    opp_pts: '2',
                    points: '11',
                    result: 'W',
                },
                {
                    date: 'Jun 16, 2025',
                    location: 'away',
                    opp: 'Tampa Bay',
                    oppAbbr: 'TB',
                    oppId: 987346,
                    opp_pts: '7',
                    points: '1',
                    result: 'L',
                },
                {
                    date: 'Jun 17, 2025',
                    location: 'away',
                    opp: 'Tampa Bay',
                    oppAbbr: 'TB',
                    oppId: 987346,
                    opp_pts: '1',
                    points: '5',
                    result: 'W',
                },
                {
                    date: 'Jun 18, 2025',
                    location: 'away',
                    opp: 'Tampa Bay',
                    oppAbbr: 'TB',
                    oppId: 987346,
                    opp_pts: '12',
                    points: '8',
                    result: 'L',
                },
                {
                    date: 'Jun 19, 2025',
                    location: 'away',
                    opp: 'Tampa Bay',
                    oppAbbr: 'TB',
                    oppId: 987346,
                    opp_pts: '1',
                    points: '4',
                    result: 'W',
                },
                {
                    date: 'Jun 20, 2025',
                    location: 'away',
                    opp: 'N.Y. Yankees',
                    oppAbbr: 'NYY',
                    oppId: 1112,
                    opp_pts: '3',
                    points: '5',
                    result: 'W',
                },
                {
                    date: 'Jun 21, 2025',
                    location: 'away',
                    opp: 'N.Y. Yankees',
                    oppAbbr: 'NYY',
                    oppId: 1112,
                    opp_pts: '9',
                    points: '0',
                    result: 'L',
                },
                {
                    date: 'Jun 22, 2025',
                    location: 'away',
                    opp: 'N.Y. Yankees',
                    oppAbbr: 'NYY',
                    oppId: 1112,
                    opp_pts: '4',
                    points: '2',
                    result: 'L',
                },
                {
                    date: 'Jun 23, 2025',
                    location: 'home',
                    opp: 'Texas',
                    oppAbbr: 'TEX',
                    oppId: 109323,
                    opp_pts: '0',
                    points: '6',
                    result: 'W',
                },
                {
                    date: 'Jun 24, 2025',
                    location: 'home',
                    opp: 'Texas',
                    oppAbbr: 'TEX',
                    oppId: 109323,
                    opp_pts: '6',
                    points: '5',
                    result: 'L',
                },
                {
                    date: 'Jun 25, 2025',
                    location: 'home',
                    opp: 'Texas',
                    oppAbbr: 'TEX',
                    oppId: 109323,
                    opp_pts: '7',
                    points: '0',
                    result: 'L',
                },
                {
                    date: 'Jun 27, 2025',
                    location: 'home',
                    opp: 'Tampa Bay',
                    oppAbbr: 'TB',
                    oppId: 987346,
                    opp_pts: '8',
                    points: '22',
                    result: 'W',
                },
                {
                    date: 'Jun 28, 2025',
                    location: 'home',
                    opp: 'Tampa Bay',
                    oppAbbr: 'TB',
                    oppId: 987346,
                    opp_pts: '11',
                    points: '3',
                    result: 'L',
                },
                {
                    date: 'Jun 29, 2025',
                    location: 'home',
                    opp: 'Tampa Bay',
                    oppAbbr: 'TB',
                    oppId: 987346,
                    opp_pts: '1',
                    points: '5',
                    result: 'W',
                },
                {
                    date: 'Jun 30, 2025',
                    location: 'away',
                    opp: 'Texas',
                    oppAbbr: 'TEX',
                    oppId: 109323,
                    opp_pts: '6',
                    points: '10',
                    result: 'W',
                },
                {
                    date: 'Jul 1, 2025',
                    location: 'away',
                    opp: 'Texas',
                    oppAbbr: 'TEX',
                    oppId: 109323,
                    opp_pts: '10',
                    points: '2',
                    result: 'L',
                },
                {
                    date: 'Jul 2, 2025',
                    location: 'away',
                    opp: 'Texas',
                    oppAbbr: 'TEX',
                    oppId: 109323,
                    opp_pts: '6',
                    points: '0',
                    result: 'L',
                },
                {
                    date: 'Jul 4, 2025',
                    location: 'away',
                    opp: 'Atlanta',
                    oppAbbr: 'ATL',
                    oppId: 56422,
                    opp_pts: '2',
                    points: '3',
                    result: 'W',
                },
                {
                    date: 'Jul 5, 2025',
                    location: 'away',
                    opp: 'Atlanta',
                    oppAbbr: 'ATL',
                    oppId: 56422,
                    opp_pts: '6',
                    points: '9',
                    result: 'W',
                },
                {
                    date: 'Jul 6, 2025',
                    location: 'away',
                    opp: 'Atlanta',
                    oppAbbr: 'ATL',
                    oppId: 56422,
                    opp_pts: '1',
                    points: '2',
                    result: 'W',
                },
                {
                    date: 'Jul 8, 2025',
                    location: 'home',
                    opp: 'N.Y. Mets',
                    oppAbbr: 'NYM',
                    oppId: 3562,
                    opp_pts: '7',
                    points: '6',
                    result: 'L',
                },
                {
                    date: 'Jul 10, 2025',
                    location: 'home',
                    opp: 'N.Y. Mets',
                    oppAbbr: 'NYM',
                    oppId: 3562,
                    opp_pts: '1',
                    points: '3',
                    result: 'W',
                },
                {
                    date: 'Jul 10, 2025',
                    location: 'home',
                    opp: 'N.Y. Mets',
                    oppAbbr: 'NYM',
                    oppId: 3562,
                    opp_pts: '3',
                    points: '7',
                    result: 'W',
                },
                {
                    date: 'Jul 11, 2025',
                    location: 'home',
                    opp: 'Miami',
                    oppAbbr: 'MIA',
                    oppId: 599325,
                    opp_pts: '2',
                    points: '5',
                    result: 'W',
                },
                {
                    date: 'Jul 12, 2025',
                    location: 'home',
                    opp: 'Miami',
                    oppAbbr: 'MIA',
                    oppId: 599325,
                    opp_pts: '6',
                    points: '0',
                    result: 'L',
                },
                {
                    date: 'Jul 13, 2025',
                    location: 'home',
                    opp: 'Miami',
                    oppAbbr: 'MIA',
                    oppId: 599325,
                    opp_pts: '11',
                    points: '1',
                    result: 'L',
                },
                {
                    date: 'Jul 18, 2025',
                    location: 'away',
                    opp: 'Tampa Bay',
                    oppAbbr: 'TB',
                    oppId: 987346,
                    opp_pts: '11',
                    points: '1',
                    result: 'L',
                },
                {
                    date: 'Jul 19, 2025',
                    location: 'away',
                    opp: 'Tampa Bay',
                    oppAbbr: 'TB',
                    oppId: 987346,
                    opp_pts: '4',
                    points: '3',
                    result: 'L',
                },
                {
                    date: 'Jul 20, 2025',
                    location: 'away',
                    opp: 'Tampa Bay',
                    oppAbbr: 'TB',
                    oppId: 987346,
                    opp_pts: '3',
                    points: '5',
                    result: 'W',
                },
                {
                    date: 'Jul 21, 2025',
                    location: 'away',
                    opp: 'Cleveland',
                    oppAbbr: 'CLE',
                    oppId: 234534,
                    opp_pts: '10',
                    points: '5',
                    result: 'L',
                },
                {
                    date: 'Jul 22, 2025',
                    location: 'away',
                    opp: 'Cleveland',
                    oppAbbr: 'CLE',
                    oppId: 234534,
                    opp_pts: '6',
                    points: '3',
                    result: 'L',
                },
                {
                    date: 'Jul 23, 2025',
                    location: 'away',
                    opp: 'Cleveland',
                    oppAbbr: 'CLE',
                    oppId: 234534,
                    opp_pts: '3',
                    points: '2',
                    result: 'L',
                },
                {
                    date: 'Jul 24, 2025',
                    location: 'away',
                    opp: 'Cleveland',
                    oppAbbr: 'CLE',
                    oppId: 234534,
                    opp_pts: '3',
                    points: '4',
                    result: 'W',
                },
                {
                    date: 'Jul 25, 2025',
                    location: 'home',
                    opp: 'Colorado',
                    oppAbbr: 'COL',
                    oppId: 593423,
                    opp_pts: '6',
                    points: '5',
                    result: 'L',
                },
                {
                    date: 'Jul 26, 2025',
                    location: 'home',
                    opp: 'Colorado',
                    oppAbbr: 'COL',
                    oppId: 593423,
                    opp_pts: '0',
                    points: '18',
                    result: 'W',
                },
                {
                    date: 'Jul 27, 2025',
                    location: 'home',
                    opp: 'Colorado',
                    oppAbbr: 'COL',
                    oppId: 593423,
                    opp_pts: '1',
                    points: '5',
                    result: 'W',
                },
                {
                    date: 'Jul 28, 2025',
                    location: 'home',
                    opp: 'Toronto',
                    oppAbbr: 'TOR',
                    oppId: 992,
                    opp_pts: '4',
                    points: '11',
                    result: 'W',
                },
                {
                    date: 'Jul 29, 2025',
                    location: 'home',
                    opp: 'Toronto',
                    oppAbbr: 'TOR',
                    oppId: 992,
                    opp_pts: '4',
                    points: '16',
                    result: 'W',
                },
                {
                    date: 'Jul 29, 2025',
                    location: 'home',
                    opp: 'Toronto',
                    oppAbbr: 'TOR',
                    oppId: 992,
                    opp_pts: '2',
                    points: '3',
                    result: 'W',
                },
                {
                    date: 'Jul 30, 2025',
                    location: 'home',
                    opp: 'Toronto',
                    oppAbbr: 'TOR',
                    oppId: 992,
                    opp_pts: '9',
                    points: '8',
                    result: 'L',
                },
                {
                    date: 'Aug 1, 2025',
                    location: 'away',
                    opp: 'Chi. Cubs',
                    oppAbbr: 'CHC',
                    oppId: 354,
                    opp_pts: '1',
                    points: '0',
                    result: 'L',
                },
                {
                    date: 'Aug 2, 2025',
                    location: 'away',
                    opp: 'Chi. Cubs',
                    oppAbbr: 'CHC',
                    oppId: 354,
                    opp_pts: '3',
                    points: '4',
                    result: 'W',
                },
                {
                    date: 'Aug 3, 2025',
                    location: 'away',
                    opp: 'Chi. Cubs',
                    oppAbbr: 'CHC',
                    oppId: 354,
                    opp_pts: '5',
                    points: '3',
                    result: 'L',
                },
                {
                    date: 'Aug 4, 2025',
                    location: 'away',
                    opp: 'Philadelphia',
                    oppAbbr: 'PHI',
                    oppId: 2239,
                    opp_pts: '13',
                    points: '3',
                    result: 'L',
                },
                {
                    date: 'Aug 5, 2025',
                    location: 'away',
                    opp: 'Philadelphia',
                    oppAbbr: 'PHI',
                    oppId: 2239,
                    opp_pts: '5',
                    points: '0',
                    result: 'L',
                },
                {
                    date: 'Aug 6, 2025',
                    location: 'away',
                    opp: 'Philadelphia',
                    oppAbbr: 'PHI',
                    oppId: 2239,
                    opp_pts: '1',
                    points: '5',
                    result: 'W',
                },
                {
                    date: 'Aug 8, 2025',
                    location: 'home',
                    opp: 'Athletics',
                    oppAbbr: 'OAK',
                    oppId: 45996,
                    opp_pts: '2',
                    points: '3',
                    result: 'W',
                },
                {
                    date: 'Aug 9, 2025',
                    location: 'home',
                    opp: 'Athletics',
                    oppAbbr: 'OAK',
                    oppId: 45996,
                    opp_pts: '11',
                    points: '3',
                    result: 'L',
                },
                {
                    date: 'Aug 10, 2025',
                    location: 'home',
                    opp: 'Athletics',
                    oppAbbr: 'OAK',
                    oppId: 45996,
                    opp_pts: '3',
                    points: '2',
                    result: 'L',
                },
                {
                    date: 'Aug 12, 2025',
                    location: 'home',
                    opp: 'Seattle',
                    oppAbbr: 'SEA',
                    oppId: 232323,
                    opp_pts: '1',
                    points: '0',
                    result: 'L',
                },
                {
                    date: 'Aug 13, 2025',
                    location: 'home',
                    opp: 'Seattle',
                    oppAbbr: 'SEA',
                    oppId: 232323,
                    opp_pts: '3',
                    points: '4',
                    result: 'W',
                },
                {
                    date: 'Aug 14, 2025',
                    location: 'home',
                    opp: 'Seattle',
                    oppAbbr: 'SEA',
                    oppId: 232323,
                    opp_pts: '3',
                    points: '5',
                    result: 'W',
                },
                {
                    date: 'Aug 15, 2025',
                    location: 'away',
                    opp: 'Houston',
                    oppAbbr: 'HOU',
                    oppId: 32235,
                    opp_pts: '0',
                    points: '7',
                    result: 'W',
                },
                {
                    date: 'Aug 16, 2025',
                    location: 'away',
                    opp: 'Houston',
                    oppAbbr: 'HOU',
                    oppId: 32235,
                    opp_pts: '5',
                    points: '4',
                    result: 'L',
                },
                {
                    date: 'Aug 17, 2025',
                    location: 'away',
                    opp: 'Houston',
                    oppAbbr: 'HOU',
                    oppId: 32235,
                    opp_pts: '0',
                    points: '12',
                    result: 'W',
                },
                {
                    date: 'Aug 18, 2025',
                    location: 'away',
                    opp: 'Boston',
                    oppAbbr: 'BOS',
                    oppId: 33,
                    opp_pts: '3',
                    points: '6',
                    result: 'W',
                },
                {
                    date: 'Aug 19, 2025',
                    location: 'away',
                    opp: 'Boston',
                    oppAbbr: 'BOS',
                    oppId: 33,
                    opp_pts: '3',
                    points: '4',
                    result: 'W',
                },
                {
                    date: 'Aug 21, 2025',
                    location: 'home',
                    opp: 'Houston',
                    oppAbbr: 'HOU',
                    oppId: 32235,
                    opp_pts: '7',
                    points: '2',
                    result: 'L',
                },
                {
                    date: 'Aug 22, 2025',
                    location: 'home',
                    opp: 'Houston',
                    oppAbbr: 'HOU',
                    oppId: 32235,
                    opp_pts: '10',
                    points: '7',
                    result: 'L',
                },
                {
                    date: 'Aug 23, 2025',
                    location: 'home',
                    opp: 'Houston',
                    oppAbbr: 'HOU',
                    oppId: 32235,
                    opp_pts: '9',
                    points: '8',
                    result: 'L',
                },
                {
                    date: 'Aug 24, 2025',
                    location: 'home',
                    opp: 'Houston',
                    oppAbbr: 'HOU',
                    oppId: 32235,
                    opp_pts: '2',
                    points: '3',
                    result: 'W',
                },
                {
                    date: 'Aug 25, 2025',
                    location: 'home',
                    opp: 'Boston',
                    oppAbbr: 'BOS',
                    oppId: 33,
                    opp_pts: '4',
                    points: '3',
                    result: 'L',
                },
                {
                    date: 'Aug 26, 2025',
                    location: 'home',
                    opp: 'Boston',
                    oppAbbr: 'BOS',
                    oppId: 33,
                    opp_pts: '5',
                    points: '0',
                    result: 'L',
                },
                {
                    date: 'Aug 27, 2025',
                    location: 'home',
                    opp: 'Boston',
                    oppAbbr: 'BOS',
                    oppId: 33,
                    opp_pts: '3',
                    points: '2',
                    result: 'L',
                },
            ],
            sos: 22,
            teamId: 7654,
            teamName: 'Baltimore Orioles',
            abbr: 'BAL',
            primaryColor: '#DF4601',
        },
    ],
    nfl: [],
    nba: [
        {
            averageMoneylines: {
                dog: {
                    avgML: 271.8181818181818,
                    totalGames: 11,
                },
                favorite: {
                    avgML: -170.55555555555554,
                    totalGames: 9,
                },
            },
            def: {
                defEff: 1.105,
                fouls: 23,
                oppThreePoint: 35.8,
                ppg: 114,
                reboundPercent: 51,
            },
            logoUrl: 'https://firebasestorage.googleapis.com/v0/b/line-prophet.appspot.com/o/nba%2F234345_nba.png?alt=media',
            off: {
                astTo: 1.588,
                floorPercent: 50.5,
                freeThrow: 79.9,
                offEff: 1.131,
                oppg: 116.7,
                paceofplay: 21,
                threePoint: 37.4,
            },
            recordData: {
                ats: '14-7-0',
                awayRecord: '4-5',
                conferenceRecord: '11-8',
                divisionRecord: '4-2',
                homeRecord: '8-4',
                ou: '10-11',
                record: '12-9',
            },
            schedule: [
                {
                    date: 'Oct 22, 2025',
                    location: 'home',
                    opp: 'Sacramento',
                    oppAbbr: 'SAC',
                    oppId: 23549,
                    opp_pts: '116',
                    points: '120',
                    result: 'W',
                    season: 'regular',
                },
                {
                    date: 'Oct 24, 2025',
                    location: 'away',
                    opp: 'L.A. Clippers',
                    oppAbbr: 'LAC',
                    oppId: 143454,
                    opp_pts: '129',
                    points: '102',
                    result: 'L',
                    season: 'regular',
                },
                {
                    date: 'Oct 25, 2025',
                    location: 'away',
                    opp: 'Denver',
                    oppAbbr: 'DEN',
                    oppId: 532349,
                    opp_pts: '133',
                    points: '111',
                    result: 'L',
                    season: 'regular',
                },
                {
                    date: 'Oct 27, 2025',
                    location: 'away',
                    opp: 'Utah',
                    oppAbbr: 'UTA',
                    oppId: 532,
                    opp_pts: '138',
                    points: '134',
                    result: 'L',
                    season: 'regular',
                },
                {
                    date: 'Oct 29, 2025',
                    location: 'home',
                    opp: 'Memphis',
                    oppAbbr: 'MEM',
                    oppId: 989898,
                    opp_pts: '114',
                    points: '113',
                    result: 'L',
                    season: 'regular',
                },
                {
                    date: 'Oct 31, 2025',
                    location: 'home',
                    opp: 'Utah',
                    oppAbbr: 'UTA',
                    oppId: 532,
                    opp_pts: '96',
                    points: '118',
                    result: 'W',
                    season: 'regular',
                },
                {
                    date: 'Nov 2, 2025',
                    location: 'home',
                    opp: 'San Antonio',
                    oppAbbr: 'SAS',
                    oppId: 23434,
                    opp_pts: '118',
                    points: '130',
                    result: 'W',
                    season: 'regular',
                },
                {
                    date: 'Nov 4, 2025',
                    location: 'away',
                    opp: 'Golden St.',
                    oppAbbr: 'GSW',
                    oppId: 48983,
                    opp_pts: '118',
                    points: '107',
                    result: 'L',
                    season: 'regular',
                },
                {
                    date: 'Nov 6, 2025',
                    location: 'home',
                    opp: 'L.A. Clippers',
                    oppAbbr: 'LAC',
                    oppId: 143454,
                    opp_pts: '102',
                    points: '115',
                    result: 'W',
                    season: 'regular',
                },
                {
                    date: 'Nov 8, 2025',
                    location: 'away',
                    opp: 'L.A. Clippers',
                    oppAbbr: 'LAC',
                    oppId: 143454,
                    opp_pts: '103',
                    points: '114',
                    result: 'W',
                    season: 'regular',
                },
                {
                    date: 'Nov 10, 2025',
                    location: 'home',
                    opp: 'New Orleans',
                    oppAbbr: 'NOP',
                    oppId: 8923,
                    opp_pts: '98',
                    points: '121',
                    result: 'W',
                    season: 'regular',
                },
                {
                    date: 'Nov 12, 2025',
                    location: 'away',
                    opp: 'Dallas',
                    oppAbbr: 'DAL',
                    oppId: 1232,
                    opp_pts: '114',
                    points: '123',
                    result: 'W',
                    season: 'regular',
                },
                {
                    date: 'Nov 13, 2025',
                    location: 'home',
                    opp: 'Indiana',
                    oppAbbr: 'IND',
                    oppId: 532345,
                    opp_pts: '98',
                    points: '133',
                    result: 'W',
                    season: 'regular',
                },
                {
                    date: 'Nov 16, 2025',
                    location: 'home',
                    opp: 'Atlanta',
                    oppAbbr: 'ATL',
                    oppId: 789,
                    opp_pts: '124',
                    points: '122',
                    result: 'L',
                    season: 'regular',
                },
                {
                    date: 'Nov 18, 2025',
                    location: 'away',
                    opp: 'Portland',
                    oppAbbr: 'POR',
                    oppId: 3404,
                    opp_pts: '110',
                    points: '127',
                    result: 'W',
                    season: 'regular',
                },
                {
                    date: 'Nov 21, 2025',
                    location: 'home',
                    opp: 'Minnesota',
                    oppAbbr: 'MIN',
                    oppId: 67834,
                    opp_pts: '113',
                    points: '114',
                    result: 'W',
                    season: 'regular',
                },
                {
                    date: 'Nov 23, 2025',
                    location: 'home',
                    opp: 'San Antonio',
                    oppAbbr: 'SAS',
                    oppId: 23434,
                    opp_pts: '102',
                    points: '111',
                    result: 'W',
                    season: 'regular',
                },
                {
                    date: 'Nov 24, 2025',
                    location: 'home',
                    opp: 'Houston',
                    oppAbbr: 'HOU',
                    oppId: 24454,
                    opp_pts: '114',
                    points: '92',
                    result: 'L',
                    season: 'regular',
                },
                {
                    date: 'Nov 26, 2025',
                    location: 'away',
                    opp: 'Sacramento',
                    oppAbbr: 'SAC',
                    oppId: 23549,
                    opp_pts: '100',
                    points: '112',
                    result: 'W',
                    season: 'regular',
                },
                {
                    date: 'Nov 28, 2025',
                    location: 'away',
                    opp: 'Oklahoma City',
                    oppAbbr: 'OKC',
                    oppId: 5323,
                    opp_pts: '123',
                    points: '119',
                    result: 'L',
                    season: 'regular',
                },
                {
                    date: 'Nov 29, 2025',
                    location: 'home',
                    opp: 'Denver',
                    oppAbbr: 'DEN',
                    oppId: 532349,
                    opp_pts: '130',
                    points: '112',
                    result: 'L',
                    season: 'regular',
                },
            ],
            sos: 18,
            teamId: 234345,
            teamName: 'Phoenix Suns',
            city: 'Phoenix',
            mascot: 'Suns',
            otherNames: ['PHX'],
            abbr: 'PHO',
            conference: 'Western',
            division: 'Pacific',
            primaryColor: '#1D1160',
            logo: '',
        },
        {
            averageMoneylines: {
                dog: {
                    avgML: 182.14285714285714,
                    totalGames: 7,
                },
                favorite: {
                    avgML: -425,
                    totalGames: 11,
                },
            },
            def: {
                defEff: 1.124,
                fouls: 19.8,
                oppThreePoint: 36.6,
                ppg: 115.4,
                reboundPercent: 51.8,
            },
            logoUrl: 'https://firebasestorage.googleapis.com/v0/b/line-prophet.appspot.com/o/nba%2F8922_nba.png?alt=media',
            off: {
                astTo: 1.672,
                floorPercent: 54.2,
                freeThrow: 79.8,
                offEff: 1.165,
                oppg: 119.6,
                paceofplay: 25,
                threePoint: 35,
            },
            recordData: {
                ats: '13-6-0',
                awayRecord: '8-2',
                conferenceRecord: '12-3',
                divisionRecord: '2-1',
                homeRecord: '7-2',
                ou: '13-6',
                record: '15-4',
            },
            schedule: [
                {
                    date: 'Oct 21, 2025',
                    location: 'home',
                    opp: 'Golden St.',
                    oppAbbr: 'GSW',
                    oppId: 48983,
                    opp_pts: '119',
                    points: '109',
                    result: 'L',
                    season: 'regular',
                },
                {
                    date: 'Oct 24, 2025',
                    location: 'home',
                    opp: 'Minnesota',
                    oppAbbr: 'MIN',
                    oppId: 67834,
                    opp_pts: '110',
                    points: '128',
                    result: 'W',
                    season: 'regular',
                },
                {
                    date: 'Oct 26, 2025',
                    location: 'away',
                    opp: 'Sacramento',
                    oppAbbr: 'SAC',
                    oppId: 23549,
                    opp_pts: '120',
                    points: '127',
                    result: 'W',
                    season: 'regular',
                },
                {
                    date: 'Oct 27, 2025',
                    location: 'home',
                    opp: 'Portland',
                    oppAbbr: 'POR',
                    oppId: 3404,
                    opp_pts: '122',
                    points: '108',
                    result: 'L',
                    season: 'regular',
                },
                {
                    date: 'Oct 29, 2025',
                    location: 'away',
                    opp: 'Minnesota',
                    oppAbbr: 'MIN',
                    oppId: 67834,
                    opp_pts: '115',
                    points: '116',
                    result: 'W',
                    season: 'regular',
                },
                {
                    date: 'Oct 31, 2025',
                    location: 'away',
                    opp: 'Memphis',
                    oppAbbr: 'MEM',
                    oppId: 989898,
                    opp_pts: '112',
                    points: '117',
                    result: 'W',
                    season: 'regular',
                },
                {
                    date: 'Nov 2, 2025',
                    location: 'home',
                    opp: 'Miami',
                    oppAbbr: 'MIA',
                    oppId: 123404,
                    opp_pts: '120',
                    points: '130',
                    result: 'W',
                    season: 'regular',
                },
                {
                    date: 'Nov 3, 2025',
                    location: 'away',
                    opp: 'Portland',
                    oppAbbr: 'POR',
                    oppId: 3404,
                    opp_pts: '115',
                    points: '123',
                    result: 'W',
                    season: 'regular',
                },
                {
                    date: 'Nov 5, 2025',
                    location: 'home',
                    opp: 'San Antonio',
                    oppAbbr: 'SAS',
                    oppId: 23434,
                    opp_pts: '116',
                    points: '118',
                    result: 'W',
                    season: 'regular',
                },
                {
                    date: 'Nov 8, 2025',
                    location: 'away',
                    opp: 'Atlanta',
                    oppAbbr: 'ATL',
                    oppId: 789,
                    opp_pts: '122',
                    points: '102',
                    result: 'L',
                    season: 'regular',
                },
                {
                    date: 'Nov 10, 2025',
                    location: 'away',
                    opp: 'Charlotte',
                    oppAbbr: 'CHO',
                    oppId: 532234,
                    opp_pts: '111',
                    points: '121',
                    result: 'W',
                    season: 'regular',
                },
                {
                    date: 'Nov 12, 2025',
                    location: 'away',
                    opp: 'Oklahoma City',
                    oppAbbr: 'OKC',
                    oppId: 5323,
                    opp_pts: '121',
                    points: '92',
                    result: 'L',
                    season: 'regular',
                },
                {
                    date: 'Nov 14, 2025',
                    location: 'away',
                    opp: 'New Orleans',
                    oppAbbr: 'NOP',
                    oppId: 8923,
                    opp_pts: '104',
                    points: '118',
                    result: 'W',
                    season: 'regular',
                },
                {
                    date: 'Nov 15, 2025',
                    location: 'away',
                    opp: 'Milwaukee',
                    oppAbbr: 'MIL',
                    oppId: 72342,
                    opp_pts: '95',
                    points: '119',
                    result: 'W',
                    season: 'regular',
                },
                {
                    date: 'Nov 18, 2025',
                    location: 'home',
                    opp: 'Utah',
                    oppAbbr: 'UTA',
                    oppId: 532,
                    opp_pts: '126',
                    points: '140',
                    result: 'W',
                    season: 'regular',
                },
                {
                    date: 'Nov 23, 2025',
                    location: 'away',
                    opp: 'Utah',
                    oppAbbr: 'UTA',
                    oppId: 532,
                    opp_pts: '106',
                    points: '108',
                    result: 'W',
                    season: 'regular',
                },
                {
                    date: 'Nov 25, 2025',
                    location: 'home',
                    opp: 'L.A. Clippers',
                    oppAbbr: 'LAC',
                    oppId: 143454,
                    opp_pts: '118',
                    points: '135',
                    result: 'W',
                    season: 'regular',
                },
                {
                    date: 'Nov 28, 2025',
                    location: 'home',
                    opp: 'Dallas',
                    oppAbbr: 'DAL',
                    oppId: 1232,
                    opp_pts: '119',
                    points: '129',
                    result: 'W',
                    season: 'regular',
                },
                {
                    date: 'Nov 30, 2025',
                    location: 'home',
                    opp: 'New Orleans',
                    oppAbbr: 'NOP',
                    oppId: 8923,
                    opp_pts: '121',
                    points: '133',
                    result: 'W',
                    season: 'regular',
                },
            ],
            sos: 22,
            teamId: 8922,
            teamName: 'Los Angeles Lakers',
            city: 'Los Angeles',
            mascot: 'Lakers',
            otherNames: ['LA Lakers', 'LAL', 'Los Angeles'],
            abbr: 'LAL',
            conference: 'Western',
            division: 'Pacific',
            primaryColor: '#552583',
            logo: '',
        },
    ],
    cbb: [],
    cfb: [],
    nhl: [],
};
